import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../../assets/css/style.css'
import $ from 'jquery';
import { SERVER_IP, PORT, ud, jwt, auth_response_flow,LICENSE } from '../../Server'
import axios from 'axios';
import DashboardChart from './CorporateChart'
import swal from 'sweetalert';
import CountUp from 'react-countup';

class Dashboard extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            info: {},
            site_no: 0
        }
    }
    componentDidMount() {
        this.getCorporateData();
        this.dataByLicense();

        // counter using jquery
        // $('.count').each(function () {
        //     $(this).prop('Counter',0).animate({
        //         Counter: $(this).text()
        //     }, {
        //         duration: 4000,
        //         easing: 'swing',
        //         step: function (now) {
        //             $(this).text(Math.ceil(now));
        //         }
        //     });
        // });
    }
    dataByLicense = () => {
        if (LICENSE.application_Dashboard) {
            this.setState(this.state)
        } else {
            setTimeout(() => {
                this.dataByLicense()
            }, 1000)
        }
    }
    getCorporateData = () => {
        var data = {
            s_id: 0,
            c_id: ud.main_id
        };
        var _this = this;
        let headers = {
            'user_id': (ud.id).toString(),
            'session_id': (ud.session_id).toString(),
            'user_type': (ud.usertype).toString(),
            'main_id': (ud.main_id).toString(),
            'jwt_token': (jwt),
            'c_id': (ud.c_id).toString()
        }
        axios.post(`${SERVER_IP}/dashboardValuesSite`, data, { withCredentials: true, headers: headers })
            .then(function (response) {
                if (response.status === 200) {
                    if (response.data.error == false) {
                        _this.setState({ info: response.data })
                        return
                    } else {
                        auth_response_flow(response.data, (return_response) => {
                            if (return_response.error === false && return_response.retry === true) {
                                _this.getCorporateData();
                            }
                        })
                    }
                }
            })
            .catch(function (error) {
                swal("Something Went Wrong. Please Retry.")
            });
    }
    getsite = (no) => {
        // console.log(no)
        this.setState({ site_no: no })
    }
    render() {
        return (
          <div>
            <div className="xp-breadcrumbbar">
              <div className="row">
                <div className="col-md-12 col-lg-12">
                  <h4 className="xp-page-title">Dashboard</h4>
                  <div className="xp-breadcrumb gradient-border">
                    <ol className="breadcrumb">
                      <li className="breadcrumb-item">
                        <a onClick={() => (window.location.href = "/dashboard")}>
                          <i className="icon-home"></i>
                        </a>
                      </li>
                      <li className="breadcrumb-item active" aria-current="page">
                        Simulanis UNO
                      </li>
                    </ol>
                  </div>
                </div>
              </div>
            </div>
            <div className="xp-contentbar p-30">
              <div className="row">
                <div className="col-md-6 col-lg-6 col-xl-3">
                  <div className="card m-b-30">
                    <div className="card-body">
                      <div className="xp-widget-box">
                        {/* <h4 className="xp-counter text-white"> <span className="count">{this.state.site_no} </span> </h4> */}
                        {/* <h4 className="xp-counter text-white"> {this.state.site_no}  </h4> */}
                        <div>
                          <CountUp start={0} end={this.state.site_no} delay={1} duration={2.5}>
                            {({ countUpRef }) => <span ref={countUpRef} />}
                          </CountUp>
                          <p className="mb-0">Sites</p>
                        </div>
                        <div className="xp-widget-icon xp-widget-icon-bg">
                          <i className="mdi mdi-sitemap font-25"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-6 col-lg-6 col-xl-3">
                  <div className="card  m-b-30">
                    <div className="card-body">
                      <div className="xp-widget-box">
                        {/* <h4 className="xp-counter text-white">{this.state.info.totalUsers}</h4> */}
                        <div>
                          <CountUp start={0} end={this.state.info.totalUsers} delay={1} duration={2.5}>
                            {({ countUpRef }) => (
                                <span ref={countUpRef} />
                            )}
                          </CountUp>
                          <p className="mb-0">Total users</p>
                        </div>
                        <div className="xp-widget-icon xp-widget-icon-bg">
                          <i className="mdi mdi-account-multiple font-25"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-6 col-lg-6 col-xl-3">
                  <div className="card m-b-30">
                    <div className="card-body">
                      <div className="xp-widget-box">
                        {/* <h4 className="xp-counter text-white">{this.state.info.activeUsers}</h4> */}
                        <div>
                        <CountUp start={0} end={this.state.info.activeUsers} delay={1} duration={2.5}>
                          {({ countUpRef }) => (
                              <span ref={countUpRef} />
                          )}
                        </CountUp>
                        <p className="mb-0"> Active users</p>
                        </div>
                        <div className="xp-widget-icon xp-widget-icon-bg">
                          <i className="mdi mdi-account-check font-25"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-md-6 col-lg-6 col-xl-3">
                  <div className="card m-b-30">
                    <div className="card-body">
                      <div className="xp-widget-box">
                        {/* <h4 className="xp-counter text-white">{this.state.info.totalWorkflows}</h4> */}
                        <div> 
                            <CountUp start={0} end={this.state.info.totalWorkflows} delay={1} duration={2.5}>
                            {({ countUpRef }) => (
                                <div>
                                <span ref={countUpRef} />
                                </div>
                            )}
                            </CountUp>
                            <p className="mb-0">Workflows</p>
                        </div>
                        <div className="xp-widget-icon xp-widget-icon-bg">
                          <i className="mdi mdi-file-document font-25"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {LICENSE.application_Dashboard ? (
                LICENSE.application_Dashboard.enable_analytics == 1 ? (
                  <DashboardChart
                    getsite={this.getsite}
                    no_Workflow={[this.state.info.totalWorkflows ? this.state.info.totalWorkflows : 0]}
                  />
                ) : (
                  <span className="text-danger">
                    {" "}
                    Analytics is not part of the current license.{" "}
                    <button className="btn btn-md btn-success" disabled>
                      Upgrade Now{" "}
                    </button>
                  </span>
                )
              ) : null}
            </div>
          </div>
        );
    }
}
export default Dashboard